module.exports = __webpack_public_path__ + "static/media/PurchaseRequisitionTemplate_1.0555629a.png";